// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"d4e2c77e","760":"7317df74"}[chunkId] + ".chunk.js";
};